<template>
<div >
    <p class="title">资格预审结果通知书</p>
    <div>
        <p>1、查看资格预审结果通知书信息。</p>
        <img src="../assets/help/1.5.1-1.jpg" alt="">
    </div>
</div>
</template>
<script>
export default {
    name:'center',
    data(){
        return{
            
        }

    }
}
</script>
<style>

</style>